<script>
export default {
  data() {
    return {};
  },
};
</script>

<template>
  <div class="card">
    <div class="card-body">
      <div class="d-flex flex-wrap">
        <div class="me-2">
          <h5 class="card-title mb-3">Clientes Destaque</h5>
        </div>
        <b-dropdown
          class="ms-auto"
          variant="white"
          menu-class="dropdown-menu-end"
          toggle-class="font-size-16 p-0"
          right
        >
          <template #button-content>
            <i class="mdi mdi-dots-horizontal"></i>
          </template>
          <b-dropdown-item href="#">Abrir clientes</b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item href="#">Novo cliente</b-dropdown-item>
        </b-dropdown>
      </div>

      <div data-simplebar style="max-height: 310px">
        <ul class="list-group list-group-flush">
          <li class="list-group-item py-3">
            <div class="d-flex">
              <div class="avatar-xs me-3">
                <span class="avatar-title rounded-circle bg-soft bg-primary text-primary">
                  RJ
                </span>
              </div>
              <div class="flex-grow-1">
                <h5 class="font-size-14 mb-1">
                  Cliente Testes 001
                  <small class="text-muted float-end">20/03/2023</small>
                </h5>
                <p class="text-muted">
                  R$ 48.577,00
                </p>
                <div>
                  <a href="javascript: void(0);" class="text-success"
                    ><i class="mdi mdi-reply me-1"></i> Detalhes</a
                  >
                </div>
              </div>
            </div>
          </li>

          <li class="list-group-item py-3">
            <div class="d-flex">
              <div class="avatar-xs me-3">
                <span class="avatar-title rounded-circle bg-soft bg-primary text-primary">
                  ES
                </span>
              </div>
              <div class="flex-grow-1">
                <h5 class="font-size-14 mb-1">
                  Cliente Testes 055
                  <small class="text-muted float-end">20/03/2023</small>
                </h5>
                <p class="text-muted">
                  R$ 41.400,50
                </p>
                <div>
                  <a href="javascript: void(0);" class="text-success"
                  ><i class="mdi mdi-reply me-1"></i> Detalhes</a
                  >
                </div>
              </div>
            </div>
          </li>


          <li class="list-group-item py-3">
            <div class="d-flex">
              <div class="avatar-xs me-3">
                <span class="avatar-title rounded-circle bg-soft bg-primary text-primary">
                  ES
                </span>
              </div>
              <div class="flex-grow-1">
                <h5 class="font-size-14 mb-1">
                  Cliente Testes 999
                  <small class="text-muted float-end">20/03/2023</small>
                </h5>
                <p class="text-muted">
                  R$ 32.185,00
                </p>
                <div>
                  <a href="javascript: void(0);" class="text-success"
                  ><i class="mdi mdi-reply me-1"></i> Detalhes</a
                  >
                </div>
              </div>
            </div>
          </li>


        </ul>
      </div>
    </div>
  </div>
</template>
